import axiosPublicClient from "../../../../axiosPublicClient"

const service = async (payload) => {
    const result = await axiosPublicClient.post(`/verify-consent-resign-code`, payload)
    return result.data
}

export default service
